// utils/tableColumns.js
export function createFilterableColumn(dataIndex, title, onFocusInput) {
  return {
    title: title ?? toTitleCase(dataIndex),
    dataIndex,
    width: null,
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'customRender',
    },
    onFilter(value, record) {
      return record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes(value.toLowerCase())
    },
    onFilterDropdownVisibleChange(visible) {
      if (visible && typeof onFocusInput === 'function') {
        setTimeout(() => onFocusInput(), 0);
      }
    },
  }
}

export function createSimpleColumn(dataIndex, width = null, customRender, title) {
  // console.log('title', title);
  // console.log('dataIndex', dataIndex)
  // console.log('customRender', customRender)
  // var test = customRender ?? title.toLowerCase()
  // console.log('test', test)

  return {
    title: toTitleCase(dataIndex),
    dataIndex,
    width,
    scopedSlots: {
      customRender: customRender ?? dataIndex,
    },
  }
}

export function createFilterableColumn2(title, dataIndex, onFilterDropdownVisibleChange) {
  return {
    title,
    dataIndex,
    width: null,
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
      customRender: 'customRender',
    },
    onFilter(value, record) {
      return record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes(value.toLowerCase())
    },
    onFilterDropdownVisibleChange: onFilterDropdownVisibleChange,
  }
}

export function createNumberColumn(title, dataIndex, width = 100) {
  return {
    title,
    dataIndex,
    width,
    align: 'right',
    scopedSlots: {
      customRender: dataIndex,
    },
    sorter: (a, b) => (a[dataIndex] ?? 0) - (b[dataIndex] ?? 0),
  }
}

export function createActionColumn(width = 70) {
  return {
    title: 'Action',
    scopedSlots: { customRender: 'action' },
    fixed: 'left',
    width,
  }
}

function formatCamelCase(str = '') {
  if (typeof str !== 'string') return '';
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, char => char.toUpperCase());
}

function toTitleCase(str = '') {
  if (typeof str !== 'string') return '';

  return str
    .replace(/[_-]/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .map(word => word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : '')
    .join(' ');
}
